import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from "react-router-dom";

function NotFoundPage(props) {
  const navigate = useNavigate();

  return (
    <Dialog
      open={true}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Page Not Found
      </DialogTitle>
      <DialogActions>
        <Button autoFocus onClick={() => navigate(-1)}>Back</Button>
      </DialogActions>
    </Dialog>
  )
}

export default NotFoundPage;